export const CAREGIVER_ASSIGNED_PATIENTS_DEFAULT_SORT = {
  sortedColumn: 'p.fullName',
  sortedColumnOrder: 'ascend'
}
